import Vue from "vue";
import App from "./App.vue";
import router from "./routers";
import store from "./stores";
import config from "../config";
import api from "./api";
import fun from "./plug/Fun";
import menu from "./plug/menu";
import "./components"; // 全局组件的管理
import scroll from "vue-seamless-scroll";
import marquee from "marquee-components";
Vue.config.productionTip = false;
Vue.prototype.$api = api;
Vue.prototype.$config = config;
Vue.prototype.$fun = fun;
Vue.use(scroll);
Vue.use(marquee);
window.routerChangeNum = 0;
// let headTitle = "";
let routerChangeTime = "";
let bgColor = "";
const domain = document.domain;
let platform = "华博特教育集团官网";
if (domain.indexOf("xueli") > -1) {
  platform = "华博特教育集团成人教育官网";
} else if (domain.indexOf("zikao") > -1) {
  platform = "华博特教育集团自学考试官网";
} else if (domain.indexOf("zhijiao") > -1) {
  platform = "华博特教育集团职业教育官网";
}
router.beforeEach(async (to, from, next) => {
  routerChangeTime = setTimeout(() => {
    fun.loading.show();
  }, 20);

  if (window.routerChangeNum === 0) {
    //路由第一次进入
    await menu.init();
  }

  await store.dispatch("storeReady");

  // 设置菜单样式
  menu.routerChange(to);

  // 设置标题
  // if (to.meta.title) {
  //   headTitle = to.meta.title;
  // } else {
  //   headTitle = "华博特官网";
  // }
  // 设置背景色
  if (to.meta.bgColor) {
    bgColor = to.meta.bgColor;
  } else {
    bgColor = "#ffffff";
  }
  document.getElementsByTagName("body")[0].style.backgroundColor = bgColor;
  document.getElementsByTagName("title")[0].textContent = platform;
  next();

  window.routerChangeNum++;
});
router.beforeResolve((to, from, next) => {
  clearTimeout(routerChangeTime);
  setTimeout(() => {
    let gBdEl = document.querySelector("html");
    if (gBdEl) gBdEl.scrollTo(0, 0);

    fun.loading.hide();
  }, 20);

  next();
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
